<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();

const links = computed(() => {
  return contentAttributes.value.items || [];
});

const extractDomain = url => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace('www.', '');
  } catch {
    return url;
  }
};
</script>

<template>
  <BaseBubble class="p-3 overflow-hidden" data-bubble-name="links">
    <div v-if="content" class="mb-3 text-sm">{{ content }}</div>
    <div class="space-y-2">
      <a
        v-for="(link, index) in links"
        :key="index"
        :href="link.uri"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center p-2 border border-n-slate-6 rounded-lg bg-n-slate-2 hover:bg-n-slate-3 transition-colors skip-context-menu group"
      >
        <div
          class="flex-shrink-0 w-8 h-8 bg-n-slate-4 rounded-md flex items-center justify-center mr-3"
        >
          <svg
            class="w-4 h-4 text-n-slate-11"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
            />
          </svg>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium text-n-slate-12 truncate">
            {{ extractDomain(link.uri) }}
          </div>
          <div class="text-xs text-n-slate-11 truncate">
            {{ link.uri }}
          </div>
        </div>
        <div class="flex-shrink-0 ml-2">
          <svg
            class="w-4 h-4 text-n-slate-11 group-hover:text-n-slate-12 transition-colors"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </div>
      </a>
    </div>
  </BaseBubble>
</template>
